import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
	MagnifyingGlassIcon,
  XCircleIcon
  } from '@heroicons/react/24/solid'
import SearchTile from './SearchTile';
import * as amplitude from '@amplitude/analytics-browser';

function compare(a, b) {

  const scoreA = a.score;
  const scoreB = b.score;

  let comparison = 0;
  if (scoreA > scoreB) {
    comparison = 1;
  } else if (scoreA < scoreB) {
    comparison = -1;
  }
  return comparison * -1;
}

export default function SearchModal({open, close}) {

  const [ searchValue, setSearchValue ] = useState('');
  const [ filterTimeout, setFilterTimeout ] = useState(null);
  const [ searchResults, setSearchResults ] = useState([]);

  const inputBoxRef = useRef(null);

  // When open is true place text focus on the input
  useEffect(() => {
    setTimeout(() => {
      if (open) { 
        inputBoxRef.current?.focus();
      }
    }, 500);
  }, [open]);

  const cancelButtonRef = useRef(null)

  var searchHeaders = new Headers();
  searchHeaders.append("Content-Type", "application/json");
  searchHeaders.append("Authorization", "Bearer 467c6d1f6638d2ccb280591fd5a48ac979099975");


  async function handleSearch(value) {
    amplitude.track('Activate Modal Search', {
      value
    });
    typeof window !== "undefined" && window?.gtag && window.gtag("event", "uber_search", { 
      'event_category': 'query',
      'value': value
     })
    fetch('https://ms-122b7c759d5a-6091.lon.meilisearch.io/multi-search', {
        method: 'POST',
        headers: searchHeaders,
        body: JSON.stringify({
            "queries": [
              {
                "indexUid": "tiluk-blog",
                "q": value,
                "limit": 6,
                "attributesToRetrieve": [
                  "Title",
                  "Excerpt",
                  "Slug",
                  "publishedAt",
                  "FeatureImageUrl",
                  "FeatureImage",
                  "PostType"
                ],
                "attributesToHighlight": [
                  "Title",
                  "Excerpt"
                ],
                "sort": ["timestamp:desc"],
                "showRankingScore": true
              },
              {
                "indexUid": "til-www-page",
                "q": value,
                "limit": 3,
                "attributesToRetrieve": [
                  "Title",
                  "IntroTitle",
                  "slug",
                  "IntroText",
                  "HeroImage",
                  "ParentPage"
                ],
                "attributesToHighlight": [
                  "Title",
                  "IntroTitle",
                  "IntroText"
                ],
                "showRankingScore": true
              },
              {
                "indexUid": "event",
                "q": value,
                "filter": '(Region = Global OR Region = UK) AND (Audience = All OR Audience = "The Information Lab")',
                "limit": 2,
                "attributesToRetrieve": [
                    "Title",
                    "Region",
                    "StartTime",
                    "SummaryDescription",
                    "FeatureImage"
                ],
                "attributesToHighlight": [
                    "Title",
                    "SummaryDescription"
                  ],
                  "showRankingScore": true
              },
              {
                "indexUid": "employee",
                "q": value,
                "filter": 'Active = true AND Country = "UK" AND Department  != "Data School Consulting"',
                "limit": 1,
                "attributesToRetrieve": [
                    "Name",
                    "Slug",
                    "Photo",
                    "JobTitle"
                ],
                "attributesToHighlight": [
                    "Name",
                    "JobTitle"
                  ],
                  "showRankingScore": true
              }
            ]
          }),
        redirect: 'follow'
    })
        .then(res => res.json())
        .then(async (data) => {
            let results = [];
            await data.results.forEach((result) => {
                results = [...results.concat(result.hits.map((r) => {
                    return {
                        ...r,
                        type: result.indexUid
                    };
                }))];
            })
            return results;
        })
        .then((hits) => {
            const returnHits = hits.map((hit) => {
                let image = '';
                let url = '';
                let type = '';
                let title = '';
                let date = null;
                let subTitle = null;
                if (hit.type === "tiluk-blog") {
                    image = hit.FeatureImage ? hit.FeatureImage.formats?.medium?.url : hit.FeatureImageUrl;
                    url = `/community/blog/${hit.Slug}`;
                    type=hit.PostType;
                    title = hit["_formatted"]?.Title ? hit["_formatted"]?.Title : hit.Title;
                    const publishedDate = new Date(hit.publishedAt)
                    date = publishedDate.toLocaleDateString('en-GB', { timeZone: 'GMT' });
                } else if (hit.type === "til-www-page") {
                    image = hit.HeroImage?.formats?.medium?.url;
                    url = `/${hit.slug}`;
                    type = 'Page';
                    title = hit["_formatted"]?.Title ? hit["_formatted"]?.Title : hit.Title;
                    if (hit.ParentPage) {
                      url = `/${hit.ParentPage.slug}${url}`
                      subTitle = hit.ParentPage.Title;
                    }
                    if (hit.ParentPage?.ParentPage) {
                      url = `/${hit.ParentPage?.ParentPage?.slug}${url}`;
                      subTitle = `${hit.ParentPage?.ParentPage?.Title} > ${subTitle}`;
                    }
                } else if (hit.type === "event") {
                    const startDate = new Date(hit.StartTime)
                    const eventTitle = hit.Title?.replace(/[\W_]+/g,"-").toLowerCase();
                    let slug = `${hit.Region}/${startDate?.toLocaleString("default", { year: "numeric" })}/${startDate?.toLocaleString("default", { month: "2-digit" })}/${eventTitle}`
                    image = hit.FeatureImage?.formats?.medium?.url;
                    url = `/community/event/${slug}`;
                    title = hit["_formatted"]?.Title ? hit["_formatted"]?.Title : hit.Title;
                    type = 'Event';
                    date = startDate.toLocaleDateString('en-GB', { timeZone: 'GMT' })
                } else if (hit.type === "employee") {
                  url = `/about/team/${hit.Slug}`
                  image = hit.Photo?.formats?.medium?.url;
                  type = 'Employee';
                  title = hit["_formatted"]?.Name ? hit["_formatted"]?.Name : hit.Name;
                  subTitle = hit.JobTitle;
              }
                return {
                    type,
                    title,
                    url,
                    image,
                    date,
                    subTitle,
                    score: hit["_rankingScore"]
                }
            });
            setSearchResults(returnHits.sort(compare));
        })
  }

  function handleChange(value) {
    setSearchValue(value);
    if (filterTimeout) clearTimeout(filterTimeout);
        setFilterTimeout(setTimeout(() => {
            handleSearch(value)
        }, 500));
    }

  function handleClear(close) {
    typeof window !== "undefined" && window?.gtag && window.gtag("event", "uber_search", { 
      'event_category': 'cancel',
      'value': searchValue
     })
    setSearchValue('');
    close();
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={() => handleClear(close)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
          <div className="flex min-h-full justify-center p-4 text-center items-baseline sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-xl sm:p-6">
                <div className=''>
                    <div className="flex">
                      <div className='relative w-full'>
                        <input
                        type="text"
                        name="search"
                        id="search"
                        className="block w-full sm:text-sm  h-[50px] py-[15px] px-[20px] ring-transparent"
                        placeholder="Search anything..."
                        ref={inputBoxRef}
                        value={searchValue || ''}
                        onChange={(e) => {
                            handleChange(e.target.value)
                        }}
                        />
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        {searchValue && searchValue?.length > 0 ? null : <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                        </div>
                      </div>
                      <Transition
                        as={Fragment}
                        show={searchValue?.length > 0}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-x-4 sm:translate-x-0 sm:scale-95"
                        enterTo="opacity-100 translate-x-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-x-0 sm:scale-100"
                        leaveTo="opacity-0 translate-x-4 sm:translate-x-0 sm:scale-95"
                      >
                        <button className='flex items-center mx-2 rounded-md' onClick={() => handleClear(close)} >
                        <XCircleIcon className="h-5 w-5 text-gray-400 mr-1" aria-hidden="true" /> Cancel
                        </button>
                      </Transition>
                    </div>
                    {searchResults?.length > 0 ? <div className='mt-6 grid space-y-3'>
                        {searchResults.map((result) => <SearchTile key={result.title} title={result.title} image={result.image} url={result.url} type={result.type} date={result.date} subTitle={result.subTitle} searchValue={searchValue}/>)}
                    </div> : null}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
